import store from "@/store";
import { checkDocumentExist } from "@/api/documentexist";

export const settingZoneExplain = parentVue => {
    return {
        description:
            "<p>Here is the place you can upload your certs, the certs information will appear after you upload them.</p>"
    };
};

export const keypairname = parentVue => {
    var vm = parentVue.$refs.rcmTable;
    return {
        description: "<p>The name of your certs, must be unique.</p>",
        showInTable: true,
        formTypes: ["createForm"],
        defaultVal: "",
        formRender: "FormInput",
        validate: [
            {
                required: true,
                message: `${parentVue.$i18n.t("certsmanage.keypairname")} ${parentVue.$i18n.t(
                    "rcmtable.validateEmptyText"
                )}`,
                trigger: "blur"
            },
            {
                validator: (rule, value, callback, source, options) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (!/^[a-z0-9\-\_\.]*$/.test(value))
                        return callback(
                            new Error(`${vm.$i18n.t("rcmtable.validateIllegalCharsPrefix")}: a-z 0-9 - _ .`)
                        );
                    if (value.length > 63)
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateExceedLengthPrefix")}: 63`));
                    if (value.endsWith("_acme") || value == "self-sign")
                        return callback(new Error("System Reserved Name"));
                    checkDocumentExist({
                        topic: "keyPairId",
                        fieldVal: value,
                        groupName: vm.formData.groupName
                    }).then(result => {
                        if (!result.data.success) {
                            return callback(new Error(`${value} ${vm.$i18n.t("rcmtable.validateExistText")}`));
                        }
                        callback();
                    });
                },
                trigger: "blur"
            }
        ]
    };
};

export const action = parentVue => {
    return {
        width: 140,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;

            const editBtn = h("Button", {
                props: {
                    shape: "circle",
                    icon: vm.isEditBtnDisabled ? "md-eye" : "md-create"
                },
                on: {
                    click: () => {
                        vm.editItem(params.row);
                    }
                }
            });

            var dropdownItems = [
                {
                    value: "delete",
                    title: vm.$t("rcmtable.deleteText"),
                    modalTitle: vm.$t("rcmtable.deleteText"),
                    modalContent: vm.$t("rcmtable.confirmDeleteText")
                }
            ];

            const moreBtn = h(
                "Dropdown",
                {
                    props: {
                        trigger: "click",
                        placement: "right",
                        transfer: true,
                        disabled: vm.isDeleteBtnDisabled
                    },
                    on: {
                        "on-click": value => {
                            var currentItem = dropdownItems.find(e => e.value == value);
                            vm.$Modal.confirm({
                                title: currentItem.modalTitle,
                                content: currentItem.modalContent,
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    var deleteItem = Object.assign({}, params.row);
                                    delete deleteItem._index;
                                    delete deleteItem._rowKey;

                                    vm.actionType = "delete";
                                    vm.updateData(vm.esIndex, "delete", deleteItem);
                                }
                            });
                        }
                    }
                },
                [
                    h("a", [
                        h("Button", {
                            props: {
                                shape: "circle",
                                icon: "md-more",
                                key: params.index
                            }
                        })
                    ]),
                    h(
                        "DropdownMenu",
                        {
                            slot: "list"
                        },
                        [
                            dropdownItems.map(function (item) {
                                return h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: item.value,
                                            disabled: item.disabled
                                        }
                                    },
                                    item.title
                                );
                            })
                        ]
                    )
                ]
            );

            const actionDivArray = [];

            if (vm.userCanIndex) {
                actionDivArray.push(editBtn);
            }

            if (!params.row.keypairtype || vm.$store.getters.isAdmin) {
                actionDivArray.push(moreBtn);
            }

            return h("div", actionDivArray);
        }
    };
};



// WEBPACK FOOTER //
// ./src/view/CertsManage/fields.js